export default __webpack_public_path__ + "static/compact-laminates-d2554efd2a2dd057e69da15e6893e90b.jpg";